<button aria-label="Drawer back button" class="back-button" (click)="clickEvent.emit($event)">
  <mat-icon class="back-icon" svgIcon="arrow_blue_right"></mat-icon>
</button>
